var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-flex justify-content-center" },
    [
      _c("CheckPermission", { attrs: { permission: "ED018" } }, [
        _c(
          "div",
          {
            staticClass: "mr-1",
            staticStyle: { cursor: "pointer" },
            on: {
              click: function($event) {
                return _vm.onOptionGetGeneralDetailsFile(_vm.file)
              }
            }
          },
          [
            _c("vs-icon", {
              attrs: {
                icon: "find_in_page",
                size: "medium",
                bg: "#E4E4E4",
                round: "",
                color: "gray",
                "data-cy": "details"
              }
            })
          ],
          1
        )
      ]),
      _c(
        "vs-tooltip",
        { attrs: { text: "Desplegar acciones" } },
        [
          _c(
            "vs-dropdown",
            { attrs: { "vs-custom-content": "", "vs-trigger-click": "" } },
            [
              _c(
                "a",
                { staticClass: "a-icon", attrs: { "href.prevent": "" } },
                [
                  _c("vs-icon", {
                    attrs: {
                      icon: "settings",
                      size: "medium",
                      bg: "#E4E4E4",
                      round: "",
                      color: "gray",
                      "data-cy": "options"
                    }
                  })
                ],
                1
              ),
              _c(
                "vs-dropdown-menu",
                { staticStyle: { width: "fit-content" } },
                [
                  _c(
                    "CheckPermission",
                    { attrs: { permission: "ED017" } },
                    [
                      _c(
                        "vs-dropdown-item",
                        {
                          on: {
                            click: function($event) {
                              return _vm.onOptionBinnacleFile(_vm.file)
                            }
                          }
                        },
                        [
                          _c("vs-icon", { attrs: { icon: "list" } }),
                          _vm._v(" Bitácora ")
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "CheckPermission",
                    { attrs: { permission: "ED019" } },
                    [
                      _c(
                        "vs-dropdown-item",
                        {
                          on: {
                            click: function($event) {
                              return _vm.onOptionDownloadFile(_vm.file)
                            }
                          }
                        },
                        [
                          _c("vs-icon", { attrs: { icon: "save_alt" } }),
                          _vm._v(" Descargar Acta ")
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "CheckPermission",
                    { attrs: { permission: "ED020" } },
                    [
                      _c(
                        "vs-dropdown-item",
                        {
                          on: {
                            click: function($event) {
                              return _vm.onOptionDownloadAttachments(_vm.file)
                            }
                          }
                        },
                        [
                          _c("vs-icon", { attrs: { icon: "save_alt" } }),
                          _vm._v(" Descargar adjuntos ")
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "CheckPermission",
                    { attrs: { permission: "ED022" } },
                    [
                      _c(
                        "vs-dropdown-item",
                        {
                          on: {
                            click: function($event) {
                              return _vm.onOptionCancelFile(_vm.file)
                            }
                          }
                        },
                        [
                          _c("vs-icon", { attrs: { icon: "clear" } }),
                          _vm._v(" Anular expediente ")
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "CheckPermission",
                    { attrs: { permission: "ED025" } },
                    [
                      _c(
                        "vs-dropdown-item",
                        {
                          on: {
                            click: function($event) {
                              return _vm.onOptionGetComments(_vm.file)
                            }
                          }
                        },
                        [
                          _c("vs-icon", { attrs: { icon: "chat" } }),
                          _vm._v(" Comentarios ")
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "CheckPermission",
                    { attrs: { permission: "ED027" } },
                    [
                      !_vm.isDraft
                        ? _c(
                            "vs-dropdown-item",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.onTicketFile(_vm.file)
                                }
                              }
                            },
                            [
                              _c("vs-icon", { attrs: { icon: "help" } }),
                              _vm._v(" Ticket de ayuda ")
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("span")
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }